import { useEffect } from 'react';
import { NB } from '@cerebral-inc/ui';
import { AssessmentButton } from '../shared/button';
import { clearWidgetAssessmentData } from '../shared/utils';

const { Heading, Flex, Text } = NB;

interface AssessmentIntroProps {
  handleNextPage: () => void;
  title: string;
  description: string;
  isStickyButton?: boolean;
}

const AssessmentIntro = ({
  handleNextPage,
  title,
  description,
  isStickyButton
}: AssessmentIntroProps) => {
  useEffect(() => {
    clearWidgetAssessmentData();
  }, []);

  return (
    <Flex
      minH="calc(100dvh - 58px)"
      w="100%"
      justifyContent="center"
      alignItems="center"
      px={{ base: '24px', md: '0' }}
    >
      <Flex
        maxW={{ base: '100%', sm: '480px' }}
        minH={isStickyButton ? { base: 'calc(100vh - 150px)', md: 'auto' } : {}}
        justifyContent="center"
      >
        <Text
          textAlign="center"
          mb="1.5"
          fontSize="14px"
          color="#2C46AD"
          fontFamily="Poppins"
        >
          3 minutes
        </Text>
        <Heading
          color="#1C1E21"
          fontSize="32px"
          mb="2"
          fontWeight="600"
          lineHeight="40px"
          textAlign="center"
          fontFamily="Poppins"
        >
          {title}
        </Heading>
        <Text
          fontSize="16px"
          color="#353A41"
          lineHeight="24px"
          textAlign="center"
          fontFamily="Poppins"
        >
          {description}
        </Text>
      </Flex>
      <AssessmentButton
        marginTop={description ? '48px' : '16px'}
        text="Start"
        onSubmit={handleNextPage}
        isStickyButton={isStickyButton}
      />
    </Flex>
  );
};

export default AssessmentIntro;
